module.exports = __webpack_public_path__ + "static/media/8-基础数据管理.a78e5684.png";